import { Component } from '@angular/core';
import { ButtonModule } from 'primeng/button';
import { DynamicDialogRef } from 'primeng/dynamicdialog';

@Component({
  selector: 'app-browser-popup-block-info-diag',
  standalone: true,
  imports: [ButtonModule],
  templateUrl: './browser-popup-block-info-diag.component.html',
  styleUrl: './browser-popup-block-info-diag.component.scss'
})
export class BrowserPopupBlockInfoDiagComponent {

  constructor(public _diag:DynamicDialogRef){}
}
